const RAW_UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Best-effort uid extraction from a session credential — the `uid` claim of
 * the session JWT, or the value itself when it is a bare uuid (no-key domains
 * echo the raw uuid instead of a token). `null` when neither applies.
 *
 * No signature verification happens here: the server is the only verifier.
 * This is used purely to detect that a token refresh changed the identity,
 * so the client can re-key its WebSocket and re-sync permissions.
 */
export function uidFromSessionToken(token: string): string | null {
  if (RAW_UUID_RE.test(token)) return token;
  const segments = token.split('.');
  if (segments.length !== 3) return null;
  try {
    const payload = JSON.parse(atob(segments[1].replace(/-/g, '+').replace(/_/g, '/')));
    return typeof payload?.uid === 'string' && payload.uid.length ? payload.uid : null;
  } catch {
    return null;
  }
}
